import React from 'react';
import { Monitor, Wrench } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import SHOficinaERP from '../components/SHOficinaERP';

const SCHEMA = {
  "@type": "SoftwareApplication",
  "name": "SHOficina ERP",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Windows",
  "offers": { "@type": "Offer", "priceCurrency": "BRL", "category": "Sistema de gestão para oficinas mecânicas" },
  "description": "Sistema de gestão (ERP) para oficinas mecânicas: ordens de serviço, estoque, financeiro e emissão fiscal. Revenda e suporte pela Fernando Tech.",
};

const FAQ = [
  { q: "O que é o SHOficina ERP?", a: "É um sistema de gestão para oficinas mecânicas que controla ordens de serviço, estoque, financeiro e emissão de documentos fiscais." },
  { q: "A Fernando Tech vende e dá suporte ao SHOficina?", a: "Sim. Somos revenda e oferecemos licença, instalação, treinamento e suporte do SHOficina." },
  { q: "O SHOficina emite nota fiscal?", a: "Sim. O sistema possui módulos fiscais para emissão de documentos conforme a necessidade da oficina." },
  { q: "Funciona para oficinas de qualquer tamanho?", a: "Sim. Atende desde oficinas pequenas até centros automotivos maiores, com módulos conforme a necessidade." },
  { q: "Como faço para adquirir o SHOficina?", a: "Fale com a Fernando Tech pelo WhatsApp que orientamos na contratação, instalação e treinamento." },
];

export default function ShoficinaPage() {
  return (
    <SubjectPageLayout
      path="/shoficina"
      breadcrumbName="SHOficina ERP"
      breadcrumbIcon={<Monitor className="w-3.5 h-3.5" />}
      seoTitle="SHOficina ERP — Sistema para Oficinas Mecânicas | Fernando Tech"
      seoDescription="SHOficina ERP: sistema completo de gestão para oficinas mecânicas — ordens de serviço, estoque, financeiro e emissão fiscal. Compre com revenda e suporte oficial da Fernando Tech."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Sistema para Oficinas',
        badgeIcon: <Wrench className="w-3.5 h-3.5" />,
        title: 'SHOficina ERP',
        accent: 'gestão completa da sua oficina',
        subtitle: 'Ordens de serviço, estoque, financeiro e emissão fiscal em um só sistema. Revenda oficial, licenças e suporte pela Fernando Tech.',
      }}
      cta={{ heading: 'Modernize a gestão da sua oficina', text: 'Fale com a Fernando Tech para conhecer o SHOficina, tirar dúvidas e adquirir sua licença com suporte local.' }}
    >
      <SHOficinaERP />
    </SubjectPageLayout>
  );
}
